import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent implements OnInit {

  @Input() form!: FormGroup;
  @Input() data: any[] = [];
  @Input() control: any;
  @Input() controlName: string = '';
  @Input() label!: string;
  @Input() value!: any;
  @Input() name!: any;
  @Input() filter: boolean = false;
  @Input() clearButton: boolean = false;
  @Input() submitted: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() class: string = '';
  @Input() placeholder: string = '';
  @Input() notFoundMsg: string = 'No results found';
  @Input() width!: string;
  @Input() multiple: boolean = false;

  @Output() emitSelectedValue = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  getValue(option: any) {
    if (this.value)
      return option[this.value];
    return option;
  }

  getOption(option: any) {
    if (this.name)
      return option[this.name];
    return option;
  }

  handleChange(event: any) {
    const value = {
      controlName: this.controlName,
      value: event
    }
    this.emitSelectedValue.emit(value);
  }
}
